import React from 'react';

const SpreedlyContext = React.createContext();

const { Provider, Consumer } = SpreedlyContext;
export { Provider as SpreedlyProvider, Consumer as SpreedlyConsumer };
export default SpreedlyContext;
